import React, { Component } from 'react'
import './style.css'

class Messages extends Component {
  render() {
    return (
      <div className="home-container">
        <a href="https://metabase.stapp.ca" target="_blank" rel="noopener noreferrer">
          <button>Metabase (view statistics)</button>
        </a>
        &nbsp; &nbsp;
        <a href="https://app.forestadmin.com" target="_blank" rel="noopener noreferrer">
          <button>Forest Admin (edit database)</button>
        </a>  
        &nbsp; &nbsp;
        <a href="https://app.logrocket.com/sofia-tutors/website" target="_blank" rel="noopener noreferrer">
          <button>LogRocket (support + debug)</button>
        </a>  
      </div>
    );
  }
}

export default Messages;



// WEBPACK FOOTER //
// ./src/views/Home/index.js